<template>
    <v-container fluid>
        <v-card class="pa-6" color="grey-lighten-4" rounded="sm" elevation="2">
            <h3 class="text-h6 mb-6 font-weight-medium">{{ texts.title }}</h3>
            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-card class="pa-4" color="white" rounded="lg" elevation="1">
                        <v-card-title class="text-subtitle-1 font-weight-medium">{{ texts.sessions }}</v-card-title>
                        <v-card-text class="text-h5">{{ stats.visitNumber }}</v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-card class="pa-4" color="white" rounded="lg" elevation="1">
                        <v-card-title class="text-subtitle-1 font-weight-medium">{{ texts.pageViews }}</v-card-title>
                        <v-card-text class="text-h5">{{ stats.viewedPageNumber }}</v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'SummaryStats',
    props: {
        stats: {
            type: Object,
            required: true
        }
    },
    computed: {
        texts() {
            return {
                title: this.$t('Statistic.summary.title'),
                sessions: this.$t('Statistic.summary.sessions'),
                pageViews: this.$t('Statistic.summary.pageViews')
            };
        }
    }
};
</script>
